// Единый формат отображения телефона везде в диспетчерской — 8 (XXX) XXX-XX-XX.
// Ввод уже маскируется компонентом PhoneInput — это только для вывода уже
// сохранённых номеров (в любом виде, который мог прийти из Битрикса/базы).
export function formatPhone(raw: string | null | undefined): string {
  // Тип обещает string, но реальные данные с сервера иногда расходятся с типом (как и
  // случилось с GpsPosition.technicianName) — не полагаемся вслепую, деградируем тихо
  if (!raw) return '—';
  const digits = raw.replace(/\D/g, '');
  let normalized: string;
  if (digits.length === 11 && (digits[0] === '7' || digits[0] === '8')) {
    normalized = `7${digits.slice(1)}`;
  } else if (digits.length === 10) {
    normalized = `7${digits}`;
  } else {
    return raw;
  }
  const local = normalized.slice(1);
  return `8 (${local.slice(0, 3)}) ${local.slice(3, 6)}-${local.slice(6, 8)}-${local.slice(8, 10)}`;
}
